var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button", 
  INPUT: "input",
  DATE_PICKER: "date_picker",
  DATETIME_PICKER: "datetime_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let tab_name = "notice";
let arr = [
  {
    id: "from_user",
    label: "送信者",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    api_tab_label:"from_user_shimei",
    api_mode:"on_new_set_logged_user_no_edit",
    tab_size:20
  },
  {
    id: "to_company",
    label: "所管会社",
    type: types.SELECT_BOX4,
    page_controller: true,
    api_uniq_grouping:true,
    default_from_local_storage:"userCompany",
    api: "/master_company/list_company_name"
  },
  {
    id: "to_department",
    label: "所管部署",
    type: types.SELECT_BOX4,
    api: "/master_belongs/list_department",
    limit_department_on_search: true,
    default_from_local_storage:"userDepartment",
    page_controller: true,
    api_uniq_grouping:true,
    search_option: {
      define_department_limit_to_key: "license_jurisdiction_team",
    },
  },
  {
    id: "to_team",
    label: "所管チーム",
    type: types.SELECT_BOX4,
    api: "/master_belongs/list_team_and_department",
    api_field_name: "team",
    default_from_local_storage:"userTeam",
    api_uniq_grouping:true,
    limit_department_on_search: true,
    page_controller: true,
    search_option: {
      define_department_limit_by_key: "licensed_department",
      api_field_name: "department",
    }
  },
  {
    id: "to_user",
    label: "ユーザ名",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    api_tab_label:"to_user_shimei",
    page_controller: true,
    page_controller_use_key_name:true,
    api_complement_array:[{user_id:"all_users",user_shimei:"全ユーザ",to_user_shimei:"全ユーザ"}],
    style: "max-width: 160px;",
    tab_size:20
  },
  {
    id:"from_user_shimei",
    label:"送信者*",
    type: types.INPUT,
  },
  {
    id:"to_user_shimei",
    label:"宛先*",
    type: types.INPUT,
  },
  {
    id:"is_history",
    label:"is_history",
    type: types.INPUT,
  },
  {
    id: "message",
    label: "内容",
    field_style: "",
    type: types.TEXT_AREA,
    tab_size:60
  },
  {
    id: "importance",
    label: "メッセージの重要度",
    type: types.SELECT_BOX2,
    options: [
      {
        label: "緊急",
        value: 9,
        style:"color:red"
      },
      {
        label: "重要",
        value: 6,
        style:""
      },
      {
        label: "連絡",
        value: 3,
        style:""
      },
      // {
      //   label: "",
      //   value: "0",
      //   style:""
      // }
    ],
    tab_size:5
  },
  {
    id: "history_date",
    label: "削除日",
    type: types.INPUT,
    tab_size:5
  },
  {
    id: "create_date",
    label: "登録日",
    type: types.DATE_PICKER,
    tab_size:5
  },
  {
    id: "message_schedule",
    label: "メッセージ追加日時",
    type: types.DATETIME_PICKER,
    tab_size:5
  },

  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
];

var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_notice.js